module.exports = __webpack_public_path__ + "img/kefu.723fa433.png";